import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AuthWrapper = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only check for admin routes (not login)
    if (location.pathname.startsWith('/blog/admin') && !location.pathname.includes('/login')) {
      if (!loading && !isAuthenticated) {
        // Not authenticated, redirect to login
        navigate('/blog/admin/login');
      }
    }
  }, [location.pathname, isAuthenticated, loading, navigate]);

  return children;
};

export default AuthWrapper;